module.exports = __webpack_public_path__ + "img/intothecosmos.3e9f1724.svg";